module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/43c143c16bc7fc957f1f8687c5830025.png";